<template>
  <v-layout row justify-end>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Edit datum</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="clearForm()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
          <v-card-text>
            <v-layout pa-5>
              <v-flex xs12>
                <v-text-field label="Datum" v-model="editDatumData.DatumName"></v-text-field>
                <v-text-field label="Description" v-model="editDatumData.DatumDescription"></v-text-field>
                <v-select label="Datum Type" v-model="editDatumData.DatumType.Name" :items="[datumType.Height, datumType.Depth]"></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="submit()">
              <v-icon class="mr-1">done</v-icon>Save
            </v-btn>
            <v-btn color="secondary" outline @click="clearForm()">Close</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-layout>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const datums = createNamespacedHelpers('datum')

  export default {
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      datumList: {
        type: Array,
        default: () => [],
      },
      datumDetail: {
        type: Object,
        default: () => {},
      },
      name: {
        type: String,
      },
    },
    data() {
      return {
        dialog: '',
        datumType: {
          Height: 'Height',
          Depth: 'Depth',
        },
        snackbar: '',
        snackColor: '',
        snackMessage: '',
        valid: true,
        editDatumData: {
          DatumType: {
            Name: '',
          },
        },
      }
    },
    mounted() {},
    computed: {

    },
    watch: {
      show() {
        this.dialog = true
        this.editDatumData = JSON.parse(JSON.stringify(this.datumDetail))
      },
    },
    methods: {
      ...datums.mapActions(['putDatum']),
      submit() {
        var self = this
        var newData = {
          DatumName: this.editDatumData.DatumName,
          DatumDescription: this.editDatumData.DatumDescription,
          Id: this.editDatumData.Id,
          DatumType: {
            Name: this.editDatumData.DatumType.Name,
            Id: this.editDatumData.DatumType.Id,
          },
          DatumTypeId: this.editDatumData.DatumTypeId,
          Tenant: this.editDatumData.Tenant,
        }
        if (this.$refs.form.validate()) {
          let options = {
            tenantName: this.name,
            data: newData,
            successCb: () => {
              self.$emit('refreshDatumList')
              self.successCb()
            },
          }
          this.putDatum(options)
        } else {
          this.failedCb()
        }
      },
      clearForm() {
        this.$refs.form.reset()
        this.dialog = false
      },
      successCb() {
        this.snackMessage = 'Datum updated successfully'
        this.snackColor = 'success'
        this.snackbar = true
        this.clearForm()
      },
      failedCb() {
        this.snackColor = 'error'
        this.snackMessage = 'Error updating datum'
        this.snackbar = true
      },
    },
  }
</script>